// import { OpenAI } from 'openai';
const key = process.env.OPENAI_API_KEY

const configuration = {
  apiKey: key,
  dangerouslyAllowBrowser: true,
}

const openai = {} // new OpenAI(configuration);

export default openai
